import { Transform, Type } from 'class-transformer';
import {
  IsBoolean,
  IsDefined,
  IsEnum,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsString,
  Min,
  ValidateNested,
} from 'class-validator';
import { EcomBaseProduct } from './base-product';

export class EcomAccessoryPackage {
  @Transform((p) => p?.toString(), { toClassOnly: true })
  @IsDefined()
  @IsString()
  packageID!: string;

  @IsDefined()
  @IsString()
  packageImage!: string;

  @IsDefined()
  @IsString()
  packageName!: string;

  @IsDefined()
  @IsString()
  menuCode!: string;

  @IsDefined()
  @IsNumber()
  @Min(0)
  packagePrice!: number;

  @IsOptional()
  @IsBoolean()
  tintAvailable?: boolean;

  @IsDefined()
  @ValidateNested({ each: true })
  @Type(() => EcomPackageAccessory)
  accessories!: EcomPackageAccessory[];

  @IsOptional()
  @ValidateNested()
  @Type(() => EcomAccessoryPackageTintOptions)
  tint?: EcomAccessoryPackageTintOptions;

  @IsOptional()
  @IsBoolean()
  leatherPreferance?: boolean;

  @IsOptional()
  @IsString()
  leatherPreferanceComponentCode?: string;

  @IsOptional()
  @IsString()
  productCategoryName?: string;
  
  @IsOptional()
  @Transform((v) => v === 'Yes')
  interestedIn?: boolean;

  @IsOptional()
  isOpted?: boolean;
}

// tslint:disable-next-line: max-classes-per-file
export class EcomPackageAccessory extends EcomBaseProduct {
  @IsOptional()
  @IsString()
  bodyType?: string;

  @IsDefined()
  @IsString()
  partNumber!: string;

  @IsDefined()
  @IsString()
  menuCode!: string;

  @IsOptional()
  @IsNumber()
  tintLevel?: number;

  @IsDefined()
  @IsString()
  componentCode!: string;

  @IsOptional()
  @Transform((v) => v === 'Yes', { toClassOnly: true })
  @IsBoolean()
  includeinInsurance?: boolean;

  @IsOptional()
  @IsNumber()
  offerPrice!: number;

  @IsOptional()
  @IsNumber()
  discount!: number;
}

// tslint:disable-next-line: max-classes-per-file
export class EcomAccessoryPackageTintOptions {
  @IsOptional()
  @IsBoolean()
  @Transform((p) => p === 'Yes')
  checkRows?: boolean;

  @IsOptional()
  @IsNumber()
  @Min(0)
  tintRows?: number;

  @IsDefined()
  @IsString()
  @IsNotEmpty()
  componentCode!: string;
}
